import { Injectable, inject } from '@angular/core';
import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { IrisDmsPermissionsSandbox } from '@iris/common/modules/dms/sandbox/dms-permissions.sandbox';
import { IrisDmsDataUploadHelper } from '@iris/common/modules/dms/helpers/dms-data-upload.helper';
import { IrisDmsFoldersSandbox } from '@iris/common/modules/dms/sandbox/dms-folders.sandbox';
import { ToastService } from '@ngx-strakit/cdk/controls/toast';
import { TranslateService } from '@ngx-translate/core';
import { of, switchMap, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IrisDmsDragAndDropHelper {
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);
  private readonly dmsPermissionsSandbox = inject(IrisDmsPermissionsSandbox);
  private readonly dmsFoldersSandbox = inject(IrisDmsFoldersSandbox);
  private readonly dmsDataUploadHelper = inject(IrisDmsDataUploadHelper);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);

  private readonly selectedFolderId = this.dmsFoldersSandbox.selectedFolderId;

  public dataDropped(dragData: DataTransfer, dropData: Record<string, string>, folderId = dropData.id, folderName = dropData.name): void {
    const data = this.dmsDataUploadHelper.getDataTransferData(dragData);
    const dropFolderId = dropData.folderId;
    const dragFolderId = data.folderId;
    const dragEntitiesIds = data.entitiesIds;
    const dragDataItems = data.items;
    if (!!data.dragId && dropData.dragId !== data.dragId) {
      this.toastService.error({ message: this.translateService.instant('text.dms.DragAndDropBetweenWindows') });
      return;
    }
    this.dmsPermissionsSandbox.hasUserUpdatePermissionForFolderRequest$(dropFolderId).pipe(
      take(1),
      switchMap(hasTargetAccess => {
        if (!hasTargetAccess) { return of(); }

        const selectedFolderId = this.selectedFolderId();
        if (!!dragEntitiesIds.length && this.selectedFolderId() !== dropFolderId && !dragEntitiesIds.includes(dropFolderId)) {
          this.dmsModalsSandbox.moveContentEntities(dragEntitiesIds, dropFolderId, selectedFolderId);
          return of();
        }
        if (!!dragFolderId && dropData.dragId === data.dragId) {
          return this.dmsPermissionsSandbox.hasUserUpdatePermissionForFolderRequest$(dragFolderId).pipe(
            take(1),
            tap(hasAccess => {
              if (!hasAccess) { return; }
              if (dragFolderId !== dropFolderId) {
                this.dmsModalsSandbox.moveFolder(dragFolderId, dropFolderId);
              }
            }),
          );
        } else if (dragDataItems.length) {
          this.dmsDataUploadHelper.uploadFilesOrFolderWithFiles(data, folderId, folderName);
        }
        return of();
      }),
      take(1),
    ).subscribe();
  }
}
